var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7227 9L12.167 6.10437H9.38859V4.22531C9.38859 3.43313 9.77672 2.66094 11.0211 2.66094H12.2842V0.195625C12.2842 0.195625 11.138 0 10.042 0C7.75391 0 6.25828 1.38688 6.25828 3.8975V6.10437H3.71484V9H6.25828V16H9.38859V9H11.7227Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebookIcon);
export default __webpack_public_path__ + "static/media/footerFacebookIcon.1a533a374a3a75548dd518855dc48741.svg";
export { ForwardRef as ReactComponent };